import { IApplicationState } from '@store'

export const selectMedia = (state: IApplicationState) => state.media.media

export const selectMediaIsUploading = (state: IApplicationState, uploadId: string) =>
  state.media.uploading.includes(uploadId)
